import { createAction, createSlice } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';

import type { Credentials, UserAccess } from '../lib/types';
import { authApi, userApi, tokenWrapper } from '../lib/api';
import type { Employee } from '../lib/types';
import type { Profile } from '../lib/types/user';

export type { Profile } from '../lib/types/user';

export type AuthState = {
  profile: Partial<Profile>;
};

export const FETCH_PROFILE = 'vehicles/auth/fetch-profile';
const initialState: AuthState = {
  profile: {
    access: []
  }
};

const fetchProfileAction = createAction<Profile>(FETCH_PROFILE);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchProfileAction, (state, { payload }) => ({
      ...state,
      profile: payload
    }));
  }
});

export const authActions = {
  fetchProfile: fetchProfileAction
};

export const login =
  (credentials: Credentials) =>
  async (): Promise<void> => {
    const result = await authApi.login(credentials);
    if (result) {
      const { accessToken } = result;
      tokenWrapper.setToken(accessToken);
    } else {
      throw new Error('login failed');
    }
  };

export const fetchProfile = () => async (
  dispatch: Dispatch
): Promise<Profile> => {
  const profile = await userApi.fetchProfile();
  dispatch(authActions.fetchProfile(profile));
  return profile;
};

export default authSlice.reducer;
